import React, { useState, useEffect, useMemo } from "react";
import { Pencil } from 'lucide-react'

import "./App.css";
import {
  getAccess,
  removeLogin,
  isLoggedIn,
  decodeJwtPayload,
} from "./Services/LoginService";
import { exportarRelatorioVacinacao } from "./Services/ExportRelatorio";

import {
  getVaccineData,
  getFarmaceuticos,
  getType,
  PostData,
  formatarCPF,
  newVacinacaoModel,
  formatarDate,
  getFarmaceuticoLocalStorage,
  getTypeDose,
  formatarDataHora,
} from "./Services/ConvenioService";

import logo from "./assets/logo.png";
import {PROFISSIONAL_SAUDE, GESTANTE} from "./assets/constants"
import { useDebounce } from "./Hooks/useDebounce";

// Senha de confirmação para cancelamento
 const PASSWORD = "M0c@C@ncel";

function App() {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [vaccineData, setVaccineData] = useState([]);
  const [loggedIn, setLoggedIn] = useState(isLoggedIn());
  const [search, setSearch] = useState("");
  const [pharmacists, setPharmacists] = useState([]);
  const [patient, setPatient] = useState(undefined);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(15);
  const [print, setPrint] = useState(false);
  const [dataPrint, setDataPrint] = useState(false);
  const [hide, setHide] = useState(false);

  const [loadingAccess, setLoadingAccess] = useState(false);
  const [loadingPatient, setLoadingPatient] = useState(false);
  const [loadingSaving, setLoadingSaving] = useState(false);

  const [disabledTipo, setDisableTipo] = useState(false);
  const [isEmailLogin, setIsEmailLogin] = useState(false);

  const [showModalRelatorio, setShowModalRelatorio] = useState(false);
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");

  // Controle de cancelamento protegido por senha
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelPassword, setCancelPassword] = useState("");
  const [pendingCancelItem, setPendingCancelItem] = useState(null);
  const [cancelError, setCancelError] = useState("");

  // Controle de edição de data de vacinaçãp protegido por senha
  const [editError, setEditError] = useState("");
  const [editPassword, setEditPassword] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [pendingEditItem, setPendingEditItem] = useState(null);
  const [enableEditDateVaccine, setEnableEditDateVaccine] = useState(false)
  const [infoEditing, setInfoEditing] = useState({})

  useEffect(() => {
    if (loggedIn) {
      const emailLogin = sessionStorage.getItem('isEmailLogin') === 'true';
      setIsEmailLogin(emailLogin);
      fetchVaccineData();
      fetchPharmacists();
    }
  }, [loggedIn]);

  const fetchVaccineData = async () => {
    setLoadingPatient(true);
    await getVaccineData("")
      .then((response) => setVaccineData(response.data))
      .catch((error) => console.error("Erro ao obter dados da vacina:", error));
    setLoadingPatient(false);
  };

  const fetchPharmacists = () => {
    getFarmaceuticos()
      .then((response) => setPharmacists(response.data))
      .catch((error) =>
        console.error("Erro ao obter dados do farmacêutico:", error)
      );
  };

  const putVaccine = async (confirm) => {
    setLoadingSaving(true);

    let _patient = {...patient};
    let loggedUser = decodeJwtPayload();
    _patient["UsuarioLogado"] = loggedUser.usuario;
    _patient["DataNascimento"] = new Date();

    let _item = getFarmaceuticoLocalStorage();
    if (_patient["Farmaceutico"] === null) {
      _patient["Farmaceutico"] = _item.Farmaceutico;
    }

    //ENVIA COMO VAZIO PARA A API, POIS PEGA A DATA E HORA DO SERVIDOR
    if (_patient["DataHoraConfirmacao"] !== null) {
      _patient["DataHoraConfirmacao"] = null;
    }

    if (confirm) {
      _patient["Confirmacao"] = true;
    }

    if (confirm && _patient.DoseAplicada === "D1") {
      _patient["Confirmacao"] = false;
    }

    let response = await PostData(_patient);

    setLoadingSaving(false);

    return response;
  };

  const handleLogin = async () => {
    setLoadingAccess(true);
    const emailLogin = isEmail(user);
    let response = await getAccess(user, password);
    setLoadingAccess(false);

    if (!response) {
    removeLogin();
  } else {
    setLoggedIn(true);
    setIsEmailLogin(emailLogin); 
    sessionStorage.setItem('isEmailLogin', emailLogin);
  }
  };

  const handleLogout = () => {
    removeLogin();
    sessionStorage.removeItem('isEmailLogin');
    setLoggedIn(false);
    setIsEmailLogin(false);
    setVaccineData([]);
  };

  const handleSaveAndPrint = async () => {
    setHide(true);

    const response = await putVaccine(true);

    if (response.status === 200) {
      window.print();
      setPrint(false);
      setPatient(undefined);
      fetchVaccineData();
      alert("Operação realizada com sucesso!");
    } else {
      alert("Falha ao tentar salvar dados.");
    }

    setHide(false);
  };

  const handlePrint = async () => {
    setHide(true);

    await new Promise((resolve) => setTimeout(resolve, 0));

    window.print();
    setDataPrint(false);
    setPatient(undefined);
    fetchVaccineData();
    alert("Operação realizada com sucesso!");
  
    setHide(false);
  };
  

  const handleCancel = (item) => {
    setPendingCancelItem(item);
    setCancelPassword("");
    setCancelError("");
    setShowCancelModal(true);
  };

  const closeCancelModal = () => {
    setShowCancelModal(false);
    setPendingCancelItem(null);
    setCancelPassword("");
    setCancelError("");
  };

  const handleConfirmCancel = async () => {
    if (cancelPassword !== PASSWORD) {
      setCancelError("Senha inválida");
      return;
    }

    if (!pendingCancelItem) {
      return;
    }

    const confirmacao = window.confirm("Deseja continuar?");
    if (!confirmacao) {
      return;
    }

    let _patient = { ...pendingCancelItem };
    let loggedUser = decodeJwtPayload();
    _patient["UsuarioLogado"] = loggedUser.usuario;
    _patient["Cancelado"] = true;
    _patient["DoseAplicada"] = "Única";
    _patient["Confirmacao"] = false;

    let response = await PostData(_patient);

    if (response.status === 200) {
      alert("Operação realizada com sucesso!");
      setPatient(undefined);
      fetchVaccineData();
      closeCancelModal();
    } else {
      alert("Falha ao tentar salvar dados.");
    }
  };

   const handleEditDateVaccine = async () => {
    if (editPassword !== PASSWORD) {
      setEditError("Senha inválida");
      return;
    }

    setEnableEditDateVaccine(true)
  };

  const handleUpdateDateVaccine = async (data) => {
    if (!pendingEditItem) {
      return;
    }

    const confirmacao = window.confirm("Deseja continuar?");
    if (!confirmacao) {
      return;
    }

    let _patient = { ...pendingEditItem };

    let loggedUser = decodeJwtPayload();
    _patient["UsuarioLogado"] = loggedUser.usuario;
    _patient["DataHoraConfirmacao"] = infoEditing.dataConfirmacao;
    _patient["DataHoraSincronizacao"] = null;

    let response = await PostData(_patient);

    if (response.status === 200) {
      alert("Operação realizada com sucesso!");
      setPatient(undefined);
      fetchVaccineData();
      handleCancelEditDateVaccine();
    } else {
      alert("Falha ao tentar salvar dados.");
    }
  };

  const handleCancelEditDateVaccine = () => {
    setShowEditModal(false);
    setPendingEditItem(null)
    setEditError("");
    setEditPassword("");
    setEnableEditDateVaccine(false)
    setInfoEditing({})
  };

  //Aplicando um atraso na pesquina para melhorar o desempenho do filtro
  const debouncedSearch = useDebounce(search, 500); 

  //Filtro na pesquisa
  const filteredData = useMemo(() => {
    if (vaccineData.some((item) => item.Id === 0)) {
      return [];
    }

    const normalizedSearch = search.replaceAll('.', '').replaceAll('-', '').toLowerCase();
    
    return vaccineData.filter(item => {
      const paciente = item.Paciente?.toLowerCase() || '';
      const cpf = item.Cpf?.replaceAll('.', '').replaceAll('-', '').toLowerCase() || '';
      const matricula = item.Matricula?.toString().toLowerCase() || '';
      const titular = item.Titular?.toLowerCase() || '';
      const vacina = item.Vacina?.toLowerCase() || '';
      const doseAplicada = item.DoseAplicada?.toLowerCase() || '';
      const dataHoraConfirmacao = item.DataHoraConfirmacao ? formatarDate(item.DataHoraConfirmacao).toLowerCase() : '';
      const empresa = item.Empresa?.toLowerCase() || '';
  
      return (
        paciente.includes(normalizedSearch) ||
        cpf.includes(normalizedSearch) ||
        matricula.includes(normalizedSearch) ||
        titular.includes(normalizedSearch) ||
        vacina.includes(normalizedSearch) ||
        doseAplicada.includes(normalizedSearch) ||
        dataHoraConfirmacao.includes(normalizedSearch) ||
        empresa.includes(normalizedSearch)
      );
    });
  }, [vaccineData, debouncedSearch]);

  //Sempre volta para a primeira página ao mudar o valor da pesquisa,
  //para garantir que os resultados filtrados sejam exibidos corretamente.
  //Caso contrário, pode acontecer de a página atual não conter nenhum item após o filtro ser aplicado.
  useEffect(() => {
    setCurrentPage(1);
  }, [search]);
  

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const assistPatient = (item) => {
    let result = vaccineData.find((element) => element.Id === item.Id);
    result["DataHoraConfirmacao"] =
      result["DataHoraConfirmacao"] === null
        ? new Date().toString()
        : result["DataHoraConfirmacao"];
    setPatient(result);
    if (item.DoseAplicada === "D1") {
      patient["DoseAplicada"] = "D2";
    }
  };

  const dataPatient = (item) => {
    let info = vaccineData.find((element) => element.Id === item.Id);
    info["DataHoraConfirmacao"] =
    info["DataHoraConfirmacao"] === null
        ? new Date().toString()
        : info["DataHoraConfirmacao"];
    setPatient(info);
    setDataPrint(true)
  };

  const lastPage = Math.ceil(filteredData.length / itemsPerPage);
  const maxPagesToShow = 1;

  const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  const endPage = Math.min(lastPage, startPage + maxPagesToShow - 1);

  const nextPage = () => {
    if (currentPage < lastPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const TitlePagination = (title) => {
    return <label>{title}</label>;
  };

  const handleDisable = () => {
    try {
      return patient["Id"] !== 0;
    } catch {
      return false;
    }
  };

  const DoseOptions = useMemo(() => {
    const AllOptions = getTypeDose();
    if (
      !patient ||
      (patient.DoseAplicada !== "D1" && patient.DoseAplicada !== "Única")
    ) {
      return AllOptions;
    }
    return AllOptions.filter((item) => item.Name !== "D2");
  }, [patient]);

  const isEmail = (value) => /[a-zA-Z]/.test(value);


  return (
    <div className="App">
      {!loggedIn && (
        <div>
          <h1>Login</h1>
          <div className="conteiner container-login-width">
            <div className="conteiner-item form-login">
              <div>
                <label className="form-label">Usuário</label>
                <input
                  placeholder="Informe o cpf ou e-mail"
                  value={isEmail(user) ? user : formatarCPF(user)}
                  onChange={(e) => {
                    const value = e.target.value;
                    setUser(value);
                  }}
                />
              </div>
              <div>
                <label className="form-label">Senha</label>
                <input
                  placeholder="Informe a senha"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              {!loadingAccess ? (
                <div>
                  <button
                    onClick={handleLogin}
                    className="button-basic button-basic-full button-back"
                  >
                    Confirmar
                  </button>
                </div>
              ) : (
                <div>
                  <button className="button-basic button-basic-full button-back">
                    Aguarde...
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {loggedIn && patient === undefined && (
        <div>
          <h2>Listagem de Pacientes</h2>
         
            <button
              className="button-basic button-basic-medium button-error"
              onClick={handleLogout}
            >
              Sair
            </button>
         

          {isEmailLogin && (
            <button
              className="button-execel button-basic"
              onClick={() => setShowModalRelatorio(true)}
            >
              Exportar Relatório
            </button>
          )}

          {showModalRelatorio && (
            <div className="modal-overlay" onClick={() => setShowModalRelatorio(false)}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h3>Selecionar Período</h3>
                <div className="modal-field">
                  <label>Data Início:</label>
                  <input
                    type="date"
                    value={dataInicio}
                    onChange={(e) => setDataInicio(e.target.value)}
                  />
                </div>
                <div className="modal-field">
                  <label>Data Fim:</label>
                  <input
                    type="date"
                    value={dataFim}
                    onChange={(e) => setDataFim(e.target.value)}
                  />
                </div>
                <div className="modal-buttons">
                  <button
                    className="button-basic button-basic-large button-back"
                    onClick={async () => {
                      if (!dataInicio || !dataFim) {
                        alert("Preencha ambas as datas.");
                        return;
                      }
                      await exportarRelatorioVacinacao(dataInicio, dataFim);
                      setShowModalRelatorio(false);
                      setDataInicio("");
                      setDataFim("");
                    }}
                  >
                    Exportar
                  </button>
                  <button
                    className="button-basic button-basic-large button-error"
                    onClick={() => {
                      setShowModalRelatorio(false);
                      setDataInicio("");
                      setDataFim("");
                    }}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          )}

          {showCancelModal && (
            <div className="modal-overlay" onClick={closeCancelModal}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h3>Confirmar cancelamento</h3>
                <p>Digite a senha para confirmar o cancelamento.</p>
                <div className="modal-field">
                  <label>Senha:</label>
                  <input
                    type="password"
                    value={cancelPassword}
                    onChange={(e) => {
                      setCancelPassword(e.target.value);
                      setCancelError("");
                    }}
                  />
                </div>
                {cancelError && (
                  <div className="modal-error" style={{ color: "red" }}>
                    {cancelError}
                  </div>
                )}
                <div className="modal-buttons">
                  <button
                    className="button-basic button-basic-large button-back"
                    onClick={handleConfirmCancel}
                  >
                    Confirmar
                  </button>
                  <button
                    className="button-basic button-basic-large button-error"
                    onClick={closeCancelModal}
                  >
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* MODAL EDIÇÃO DATA DE ATENDIMENTO DA VACINA */}
          {showEditModal && (
            <div className="modal-overlay" onClick={() => {
              handleCancelEditDateVaccine()
            }}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h3>Edição da data de Aplicação</h3>
                {!enableEditDateVaccine ? (
                  <>
                    <p>Digite a senha para prosseguir com o cancelamento.</p>
                      <div className="modal-field">
                        <label>Senha:</label>
                        <input
                          type="password"
                          value={editPassword}
                          onChange={(e) => {
                            setEditPassword(e.target.value);
                            setEditError("");
                          }}
                        />
                      </div>
                      {editError && (
                        <div className="modal-error" style={{ color: "red" }}>
                          {editError}
                        </div>
                      )}
                      <div className="modal-buttons">
                        <button
                          className="button-basic button-basic-large button-back"
                          onClick={handleEditDateVaccine}
                        >
                          Confirmar
                        </button>
                        <button
                          className="button-basic button-basic-large button-error"
                          onClick={()=>{
                            handleCancelEditDateVaccine()
                          }}
                        >
                          Fechar
                        </button>
                      </div>
                  </>            
                ) : (
                  <>
                    <div className="modal-field">
                      <label>Data e Hora:</label>
                      <input
                        type="datetime-local"
                        value={infoEditing.dataConfirmacao}
                        onChange={(e) => setInfoEditing({dataConfirmacao: e.target.value})}
                      />
                    </div>
                    <div className="modal-buttons">
                      <button
                        className="button-basic button-basic-large button-back"
                        onClick={()=>{
                          handleUpdateDateVaccine(infoEditing)
                        }}
                      >
                        Confirmar
                      </button>
                      <button
                        className="button-basic button-basic-large button-error"
                        onClick={()=>{
                          handleCancelEditDateVaccine()
                        }}
                      >
                        Cancelar
                      </button>
                    </div>
                    
                  </>
                )}
              </div>
            </div>
          )}

          <br />
          <br />
          <div className="container">
            <div className="container-item">
              <table border="1">
                <thead>
                  <tr>
                    <th>Buscar por:</th>
                    <th colSpan="8">
                      <input
                        disabled={handleDisable()}
                        type="text"
                        placeholder="Pesquisar..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </th>
                    {!isEmailLogin && (

                    <th colSpan="2" style={{ textAlign: "center" }}>
                      <button
                        className="button-basic button-basic-medium button-back"
                        onClick={() => {
                          let element = getFarmaceuticoLocalStorage();
                          newVacinacaoModel["Farmaceutico"] =
                            element["Farmaceutico"];
                          newVacinacaoModel["CRF"] = element["CRF"];
                          newVacinacaoModel["ProfissionalSaude"] = PROFISSIONAL_SAUDE.NAO;
                          newVacinacaoModel["Gestante"] = GESTANTE.NAO;
                          setPatient(newVacinacaoModel);
                          setDisableTipo(false);
                        }}
                      >
                        Incluir
                      </button>
                    </th>
                    )}
                  </tr>
                  <tr>
                    <th style={{ minWidth: "300px", maxWidth: "300px" }}>
                      Paciente
                    </th>
                    <th style={{ minWidth: "100px", maxWidth: "100px" }}>
                      CPF
                    </th>
                    <th style={{ minWidth: "100px", maxWidth: "100px" }}>
                      Tipo
                    </th>
                    <th style={{ minWidth: "270px", maxWidth: "270px" }}>
                      Nome Titular
                    </th>
                    <th style={{ minWidth: "50px", maxWidth: "50px" }}>
                      Nro. Matrícula
                    </th>
                    <th style={{ minWidth: "220px", maxWidth: "220px" }}>
                      Vacina
                    </th>
                    <th style={{ minWidth: "60px", maxWidth: "60px" }}>
                      Dose Aplicada
                    </th>
                    <th style={{ minWidth: "120px", maxWidth: "120px" }}>
                      Data/Hora Aplicação 
                    </th>
                     <th style={{ minWidth: "220px", maxWidth: "220px" }}>
                      Empresa
                    </th>
                    {!isEmailLogin && (

                    <th style={{ minWidth: "130px", maxWidth: "130px" }}>Ação</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {!loadingPatient ? (
                    <>
                      {currentItems.map((item) => (
                        <tr
                          key={item.Id}
                          style={{
                            background: !item.Confirmacao
                              ? item.DoseAplicada === "Única"
                                ? "#fff"
                                : item.DoseAplicada === "D1"
                                ? "#d3c5ee"
                                : "#b2dfbc"
                              : "#b2dfbc",
                          }}
                        >
                          <td style={{ minWidth: "300px", maxWidth: "300px" }}>
                            {item.Paciente}
                          </td>
                          <td style={{ minWidth: "100px", maxWidth: "100px" }}>
                            {formatarCPF(item.Cpf)}
                          </td>
                          <td style={{ minWidth: "100px", maxWidth: "100px" }}>
                            {item.Tipo}
                          </td>
                          <td style={{ minWidth: "250px", maxWidth: "250" }}>
                            {item.Titular}
                          </td>
                          <td style={{ minWidth: "90px", maxWidth: "90px" }}>
                            {item.Matricula}
                          </td>
                          <td style={{ minWidth: "100px", maxWidth: "100px" }}>
                            {item.Vacina}
                          </td>
                           <td style={{ minWidth: "100px", maxWidth: "100px" }}>
                            {item.DoseAplicada}
                          </td>
                          <td style={{ minWidth: "100px", maxWidth: "100px" }}>
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                              {formatarDataHora(item.DataHoraConfirmacao)}
                              {(item.Confirmacao && isEmailLogin) &&
                                <Pencil 
                                  size={25}
                                  style={{cursor: 'pointer', color: '#243ab6cc'}}
                                  onClick={() => {
                                    setShowEditModal(true)
                                    setPendingEditItem(item)
                                    setInfoEditing({cpf: item.Cpf, dataConfirmacao: item.DataHoraConfirmacao})
                                  }}
                                />
                              } 
                            </div>   
                          </td>
                           <td style={{ minWidth: "100px", maxWidth: "100px" }}>
                            {item.Empresa}
                          </td>
                          {!isEmailLogin && (

                          <td>
                            <div className="table-btn-group">
                            {!item.Confirmacao ? (
                              <>
                                {item.DoseAplicada === "Única" && (
                                  <button
                                    className="button-basic button-basic-medium button-success button-answer"
                                    onClick={() => {
                                      let element =
                                        getFarmaceuticoLocalStorage();
                                      item["Farmaceutico"] =
                                        element["Farmaceutico"];
                                      item["CRF"] = element["CRF"];
                                      assistPatient(item);
                                      setDisableTipo(true);
                                    }}
                                    
                                  >
                                    Atender
                                  </button>
                                )}
                                {item.DoseAplicada === "D1" && (
                                  <>
                                    <div className="table-btn-group">
                                      <button
                                        className="button-basic button-basic-medium button-success"                  
                                        onClick={() => {
                                          let element =
                                            getFarmaceuticoLocalStorage();
                                          item["Farmaceutico"] =
                                            element["Farmaceutico"];
                                          item["CRF"] = element["CRF"];
                                          item["DoseAplicada"] = "D2";
                                          assistPatient(item)
                                          setDisableTipo(true);
                                        }}
                                      >
                                        D2
                                      </button>
                                      <button
                                        className="button-basic button-basic-medium button-basic-print"
                                        onClick={() =>{dataPatient(item)} }
                                      >
                                        Reimprimir
                                      </button>
                                      <button
                                        className="button-basic button-basic-medium"
                                        onClick={() => handleCancel(item)}
                                      >
                                        Cancelar
                                      </button>

                                    </div>
                                  </>
                                )}
                              </>
                            ) : (
                              <div className="table-btn-group2">
                                <button
                                  className="button-basic button-basic-medium button-basic-print"
                                  onClick={() =>{dataPatient(item)} }
                                >
                                  Reimprimir
                                </button>
                                <button
                                  className="button-basic button-basic-medium button-cancel"
                                  onClick={() => handleCancel(item)}
                                >
                                  Cancelar
                                </button>
                              </div>
                            )}
                            </div>
                            
                          </td>
                          )}
                        </tr>
                      ))}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={7} align={"center"}>
                        Aguarde...
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="conteiner container-top container-bottom">
            <div className="conteiner-item">
              <div className="pagination">
                <button
                  onClick={() => setCurrentPage(1)}
                  disabled={currentPage === 1}
                >
                  {TitlePagination("<<")}
                </button>
                <button onClick={prevPage} disabled={currentPage === 1}>
                  {TitlePagination("<")}
                </button>
                <ul className="pagination-list">
                  {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
                    const page = startPage + i;
                    const isCurrentPage = currentPage === page;
                    return (
                      <li key={page} className={isCurrentPage ? "active" : ""}>
                        <button onClick={() => paginate(page)}>{page}</button>
                      </li>
                    );
                  })}
                </ul>
                <button onClick={nextPage} disabled={currentPage === lastPage}>
                  {TitlePagination(">")}
                </button>
                <button
                  onClick={() => setCurrentPage(lastPage)}
                  disabled={currentPage === lastPage}
                >
                  {TitlePagination(">>")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {loggedIn && patient !== undefined && (
        <div>
          {print && (
            <div className="print-root">
              {[1, 2].map((via) => (
                <div  className={`print-copy ${via === 2 ? "display-disabled" : "display-enabled"}`} key={via}>
                  <div className="logo-element">
                    <img src={logo} alt="Drogal" />
                  </div>

                  <div className="print-content">
                    <div className="print-conteiner">
                      <label className="print-title"><strong>PACIENTE: </strong></label>
                      <label className="print-label">{patient["Paciente"]}</label>
                    </div>

                    <div className="print-conteiner">
                      <label className="print-title"><strong>VACINA: </strong></label>
                      <label className="print-label">{patient["Vacina"]}</label>
                    </div>

                    <div className="print-conteiner">
                      <label className="print-title"><strong>DOSE: </strong></label>
                      <label className="print-label">{patient["DoseAplicada"]}</label>
                    </div>

                    <div className="print-conteiner">
                      <label className="print-title"><strong>DATA: </strong></label>
                      <label className="print-label">
                        {formatarDate(patient["DataHoraConfirmacao"])}
                      </label>
                    </div>

                    <div className="print-conteiner">
                      <label className="print-title"><strong>LOTE: </strong></label>
                      <label className="print-label">{patient["NumeroLote"]}</label>
                    </div>

                    <div className="print-conteiner">
                      <label className="print-title"><strong>FABRICANTE: </strong></label>
                      <label className="print-label">{patient["Fabricante"]}</label>
                    </div>

                    <div className="print-conteiner">
                      <label className="print-title"><strong>CNPJ DROGAL: </strong></label>
                      <label className="print-label">{patient["DrogalCNPJ"]}</label>
                    </div>

                    <div className="print-conteiner">
                      <label className="print-title"><strong>FARMACÊUTICO: </strong></label>
                      <label className="print-label">{patient["Farmaceutico"]}</label>
                    </div>

                    <div className="print-spacer" />

                    <div className="print-conteiner">
                      <div className="crf-element">
                        <label className="print-title"><strong>CRF: </strong></label>
                        <label className="print-label">{patient["CRF"]}</label>
                      </div>
                    </div>

                    <div className="print-copy-title">{via}ª via</div>
                  </div>
                </div>
              ))}

              <div className={`print-footer ${hide ? "hide" : ""}`}>
                <div className="print-footer-item print-footer-rigth">
                  <button
                    className="button-basic button-basic-medium button-default"
                    onClick={() => setPrint(false)}
                  >
                    Voltar
                  </button>
                </div>

                <div className="print-footer-item print-footer-left">
                  <button
                    className="button-basic button-save-print"
                    onClick={handleSaveAndPrint}
                  >
                    {!loadingSaving ? "Salvar e imprimir" : "Aguarde..."}
                  </button>
                </div>
              </div>
            </div>
          )}

          {dataPrint && (
            <div className="print-root">
              <div className="print-copy">
                <div className="logo-element">
                  <img src={logo} alt="Drogal" />
                </div>

                <div className="print-content">
                  <div className="print-conteiner">
                    <label className="print-title">
                      <strong>PACIENTE: </strong>
                    </label>
                    <label className="print-label">{patient["Paciente"]}</label>
                  </div>

                  <div className="print-conteiner">
                    <label className="print-title">
                      <strong>VACINA: </strong>
                    </label>
                    <label className="print-label">{patient["Vacina"]}</label>
                  </div>

                  <div className="print-conteiner">
                    <label className="print-title">
                      <strong>DOSE: </strong>
                    </label>
                    <label className="print-label">
                      {patient["DoseAplicada"]}
                    </label>
                  </div>

                  <div className="print-conteiner">
                    <label className="print-title">
                      <strong>DATA: </strong>
                    </label>
                    <label className="print-label">
                      {formatarDate(patient["DataHoraConfirmacao"])}
                    </label>
                  </div>

                  <div className="print-conteiner">
                    <label className="print-title">
                      <strong>LOTE: </strong>
                    </label>
                    <label className="print-label">
                      {patient["NumeroLote"]}
                    </label>
                  </div>

                  <div className="print-conteiner">
                    <label className="print-title">
                      <strong>FABRICANTE: </strong>
                    </label>
                    <label className="print-label">
                      {patient["Fabricante"]}
                    </label>
                  </div>

                  <div className="print-conteiner">
                    <label className="print-title">
                      <strong>CNPJ DROGAL: </strong>
                    </label>
                    <label className="print-label">
                      {patient["DrogalCNPJ"]}
                    </label>
                  </div>

                  <div className="print-conteiner">
                    <label className="print-title">
                      <strong>FARMACÊUTICO: </strong>
                    </label>
                    <label className="print-label">
                      {patient["Farmaceutico"]}
                    </label>
                  </div>

                  <div>
                    <br />
                    <br />
                    <br />
                  </div>

                  <div className="print-conteiner">
                    <div className="crf-element">
                      <label className="print-title">
                        <strong>CRF: </strong>
                      </label>
                      <label className="print-label">{patient["CRF"]}</label>
                    </div>
                  </div>
                </div>

                <div className={`print-footer ${hide ? "hide" : ""}`}> 
                <div className="print-footer-item print-footer-rigth">
                    <button
                      className="button-basic button-basic-medium button-default"
                      onClick={() => 
                        {setDataPrint(false)
                        setPatient(undefined)}
                      }
                    >
                      Voltar
                    </button>
                  </div>  
                  <div className="print-footer-item reprint-footer-center">
                    <button
                      className="button-basic button-save-print"
                      onClick={() => { handlePrint()}}
                    >
                      {!loadingSaving ? "Imprimir" : "Aguarde..."}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {(!print && !dataPrint) && (
            <>
              <h2>Atendimento ao Paciente</h2>
              <div className="container container-width container-top">
                <div className="container-item" style={{ minWidth: "505px" }}>
                  <label className="form-label">Farmacêutico</label>
                  <select
                    id="Farmaceutico"
                    name="Farmaceutico"
                    value={patient["Farmaceutico"]}
                    onChange={(e) => {
                      let item = pharmacists.filter(
                        (item) => item.Nome === e.target.value
                      );
                      const _CRF = item.length > 0 ? item[0].CRF : "";

                      const updatedPatient = {
                        ...patient,
                        Farmaceutico: e.target.value,
                        CRF: _CRF,
                      };

                      setPatient(updatedPatient);

                      localStorage.setItem(
                        "Farmaceutico",
                        JSON.stringify({
                          Farmaceutico: e.target.value,
                          CRF: _CRF,
                        })
                      );
                    }}
                  >
                    <option key="0" value="">
                      Selecione uma opção
                    </option>
                    {pharmacists.map((item) => (
                      <option key={item.Codigo} value={item.Nome}>
                        {item.Nome}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="container-item">
                  <label className="form-label">CRF</label>
                  <input
                    disabled={handleDisable()}
                    placeholder="CRF"
                    value={patient["CRF"]}
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        CRF: e.target.value,
                      };
                      setPatient(updatedPatient);
                    }}
                  />
                </div>
              </div>

              <div className="container container-width container-top">
                <div className="container-item">
                  <label className="form-label">Paciente</label>
                  <input
                    disabled={handleDisable()}
                    placeholder="Paciente"
                    value={patient["Paciente"]}
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        Paciente: e.target.value,
                      };
                      setPatient(updatedPatient);
                    }}
                  />
                </div>
                <div className="container-item">
                  <label className="form-label">Cpf</label>
                  <input
                    disabled={handleDisable()}
                    placeholder="Cpf"
                    value={formatarCPF(patient["Cpf"])}
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        Cpf: formatarCPF(e.target.value),
                      };
                      setPatient(updatedPatient);
                    }}
                  />
                </div>
                <div className="container-item">
                  <label className="form-label" >Profissional de Saúde</label>
                  <input
                    type="checkbox"
                    checked={patient.ProfissionalSaude}
                    className="form-checkbox"
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        ProfissionalSaude: e.target.checked ? PROFISSIONAL_SAUDE.SIM : PROFISSIONAL_SAUDE.NAO,
                      };
                      setPatient(updatedPatient);
                    }}
                  />
                </div>
                <div className="container-item">
                  <label className="form-label">Gestante</label>
                  <input
                    type="checkbox"
                    checked={patient.Gestante}
                    className="form-checkbox"
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        Gestante: e.target.checked ? GESTANTE.SIM : GESTANTE.NAO,
                      };
                      setPatient(updatedPatient);
                    }}
                  />
                </div>
                {/* <div className="container-item">
                  <label className="form-label">Data Nascimento</label>
                  <input
                    disabled={handleDisable()}
                    required
                    placeholder="Data Nascimento"
                    value={formatarDate(patient["DataNascimento"])}
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        DataNascimento: e.target.value,
                      };
                      setPatient(updatedPatient);
                    }}
                  />
                </div> */}
              </div>
              <div className="container container-width container-top">
                <div className="container-item">
                  <label className="form-label">Matrícula</label>
                  <input
                    type="Number"
                    disabled={handleDisable()}
                    placeholder="Matrícula"
                    value={patient["Matricula"]}
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        Matricula: e.target.value,
                      };
                      setPatient(updatedPatient);
                    }}
                  />
                </div>
                <div className="container-item">
                  <label className="form-label">Tipo</label>
                  <select
                    id="tipo"
                    name="tipo"
                    disabled={disabledTipo}
                    value={patient["Tipo"]}
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        Tipo: e.target.value,
                      };
                      setPatient(updatedPatient);
                    }}
                  >
                    <option key="0" value="0"></option>
                    {getType().map((item) => (
                      <option key={item.Code} value={item.Name}>
                        {item.Name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="container-item">
                  <label className="form-label">Titular</label>
                  <input
                    disabled={patient["Tipo"] === "TITULAR" || handleDisable()}
                    placeholder="Titular"
                    value={patient["Titular"]}
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        Titular: e.target.value,
                      };
                      setPatient(updatedPatient);
                    }}
                  />
                </div>
              </div>
              <div className="container container-width container-top">
                <div className="container-item">
                  <label className="form-label">Vacina</label>
                  <input
                    disabled={true}
                    placeholder="Vacina"
                    value={patient["Vacina"]}
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        Vacina: e.target.value,
                      };
                      setPatient(updatedPatient);
                    }}
                  />
                </div>
                <div className="container-item">
                  <label className="form-label">Dose Aplicada</label>
                  <select
                    id="Dose"
                    name="Dose"
                    disabled={patient.DoseAplicada === "D2"}
                    placeholder="Dose Aplicada"
                    value={patient["DoseAplicada"] || ""}
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        DoseAplicada: e.target.value,
                      };
                      setPatient(updatedPatient);
                    }}
                  >
                    {DoseOptions.map((item) => (
                      <option key={item.Code} value={item.Name}>
                        {item.Name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="container-item">
                  <label className="form-label">Número do Lote</label>
                  <input
                    disabled={true}
                    placeholder="Numero Lote"
                    value={patient["NumeroLote"]}
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        NumeroLote: e.target.value,
                      };
                      setPatient(updatedPatient);
                    }}
                  />
                </div>
                <div className="container-item">
                  <label className="form-label">Fabricante</label>
                  <input
                    disabled={true}
                    placeholder="Fabricante"
                    value={patient["Fabricante"]}
                    onChange={(e) => {
                      const updatedPatient = {
                        ...patient,
                        Fabricante: e.target.value,
                      };
                      setPatient(updatedPatient);
                    }}
                  />
                </div>
              </div>
              <div
                className="container container-width container-top"
                style={{ display: "flex", justifyContent: "center" }}
              >
                {/* <div className='container-item'>
                  <label className='form-label'>Confirmado ?</label>
                  <select 
                    id="confirmacao" 
                    name="confirmacao"                 
                    value={patient["Confirmacao"]} 
                    onChange={(e)=>{ 
                      const updatedPatient = { ...patient, Confirmacao: e.target.value };
                      setPatient(updatedPatient)
                    }}>
                    <option key='0' value='false'>Não</option>
                    <option key='1' value='true'>Sim</option>                
                  </select>
                </div>             */}
                <div className="container-item save-button">
                  <button
                    className="button-basic button-basic-medium button-default"
                    onClick={() => {
                      setPatient(undefined);
                      if (patient.DoseAplicada === "D2") {
                        patient["DoseAplicada"] = "D1";
                      }
                    }}
                  >
                    Voltar
                  </button>
                </div>
                <div
                  className="container-item save-button"
                  style={{ "max-width": "124px" }}
                >
                  <button
                    type="submit"
                    className="button-basic button-warning"
                    onClick={() => {
                      if (!patient.Farmaceutico) {
                        alert("Selecione um farmacêutico");
                        return false;
                      }
                      if (!patient.Paciente) {
                        alert("Insira o nome do Paciente");
                        return false;
                      }
                      if (!patient.Cpf) {
                        alert("Insira o CPF");
                        return false;
                      }
                      setPrint(true);
                    }}
                  >
                    Salvar e imprimir
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default App;
